/**
 * NANP (US) phone number: a 10-digit national number, optionally with the
 * country code 1 in front, written with any of the usual separators.
 *
 * Area code (NPA) and exchange (NXX) both start 2-9 and neither may be an N11
 * service code (411, 911, ...). We cannot tell mobile from landline without a
 * carrier lookup, so this is a structural check — the real mobile test is the
 * opt-in confirmation SMS the backend sends on enrollment.
 */
const US_NATIONAL_NUMBER = /^([2-9](?!11)\d{2})([2-9](?!11)\d{2})(\d{4})$/

function usNationalDigits(value) {
  if (!value) return null
  const digits = String(value).replace(/\D/g, '')
  const national = digits.length === 11 && digits[0] === '1'
    ? digits.slice(1)
    : digits
  return US_NATIONAL_NUMBER.test(national) ? national : null
}

export function isValidUsPhone(value) {
  return usNationalDigits(value) !== null
}

/**
 * @returns {string|null} the number in E.164 (+1XXXXXXXXXX), or null if `value`
 * is not a valid US number. Callers must not fall back to the raw input — an
 * un-normalized number is not safe to hand to the SMS sender.
 */
export function normalizeUsPhoneToE164(value) {
  const national = usNationalDigits(value)
  return national ? `+1${national}` : null
}

export default {
  /**
   * Display / input-mask format "(NPA) NXX-XXXX". A leading US country code is
   * dropped first, so E.164 numbers ("+14805184427", which the Lite SMS channel
   * stores) render as "(480) 518-4427" rather than "(148) 051-8442".
   */
  phoneUsFormat(number) {
    if (!number) return ''
    let digits = String(number).replace(/\D/g, '')
    if (digits.length === 11 && digits[0] === '1') {
      digits = digits.slice(1)
    }
    const x = digits.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
  },
}
